import _ from "lodash";

import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { IntlActions, useTranslate } from "react-redux-multilingual";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollTop } from "components/standart";
import { clearWhatsAppMessage, setLocaleData, resetPlayer } from "actions";
import { frontendApi, userApi, authApi } from "reducers/api";
import { accessToken } from "reducers/api/token";
import BottomMenu from "components/common/bottom_menu";
import AuthTelegramWait from "views/auth/telegram-wait";
import { TelegramBackButtonOverload } from "components/standart/telegram-back-button";
import { history } from "store";
import TelegramApp from "@twa-dev/sdk";

import { YMInit } from "services";
import qs from "query-string";

import "components/common/index.scss";
import { DATA_COUNTRY_CATEGORY_HEADER, DATA_COUNTRY_HEADER } from "constants";

const MaxApp = window.WebApp;

const { env } = frontendApi.actions;
const { auth } = authApi.actions;
const { session: sessionApi, env: systemEnv } = userApi.actions;

// FBPixel.pageView();

const InitLayout = (props) => {
  const translate = useTranslate();
  const location = useLocation();
  const navigate = useNavigate();

  const { locales, userEnv, userSession } = props;
  const dispatch = useDispatch();
  const authStore = useSelector((state) => state.auth.auth);
  const { session } = useSelector((state) => state.user);

  const [telegramAuthWait, setTelegramAuthWait] = useState(false);
  const [authCheckSuccess, setAuthCheckSuccess] = useState(false);

  const telegramAuthHandler = useCallback(() => {
    // /*
    const code = TelegramApp.initData;
    const safeLogout = () => {
      dispatch(
        sessionApi.actions.logout(
          {},
          {
            onSuccess() {
              auth.actions.logout(
                {},
                {
                  onSuccess() {
                    document.location.reload(true);
                  },
                },
              );
            },
          },
        ),
      );
    };
    if (code) {
      props.telegramAuth(
        { body: { code } },
        {
          onSuccess(authToken) {
            const { type, accessToken: token } = authToken;
            localStorage.setItem(accessToken, `${type} ${token}`);
            dispatch(
              sessionApi.actions.getUser(
                {},
                {
                  onSuccess() {
                    setAuthCheckSuccess(true);
                  },
                  onFailure() {
                    safeLogout();
                  },
                },
              ),
            );
            // setTimeout(() => props.closeHandler(), 1000);
          },
          onFailure() {
            safeLogout();
          },
          onRequest() {},
        },
      );
    }
    // */
  }, [session, props]);

  const maxAuthHandler = useCallback(() => {
    // /*
    const code = MaxApp.initData;
    const safeLogout = () => {
      dispatch(
        sessionApi.actions.logout(
          {},
          {
            onSuccess() {
              auth.actions.logout(
                {},
                {
                  onSuccess() {
                    document.location.reload(true);
                  },
                },
              );
            },
          },
        ),
      );
    };
    if (code) {
      props.maxAuth(
        { body: { code } },
        {
          onSuccess(authToken) {
            const { type, accessToken: token } = authToken;
            localStorage.setItem(accessToken, `${type} ${token}`);
            dispatch(
              sessionApi.actions.getUser(
                {},
                {
                  onSuccess() {
                    setAuthCheckSuccess(true);
                  },
                  onFailure() {
                    safeLogout();
                  },
                },
              ),
            );
          },
          onFailure() {
            safeLogout();
          },
          onRequest() {},
        },
      );
    }
    // */
  }, [session, props]);

  useEffect(() => {
    if (locales.country?._id) {
      localStorage.setItem(DATA_COUNTRY_HEADER, locales.country._id);
    }

    if (userSession?.countryCategoryId) {
      localStorage.setItem(DATA_COUNTRY_CATEGORY_HEADER, userSession.countryCategoryId);
    }

    //console.log ('changes'
  }, [userSession.countryCategoryId, locales.country]);

  useEffect(() => {
    if (locales.data?._id) {
      props.landings({ query: { localeId: locales.data._id } });
      props.meta({ query: { localeId: locales.data._id } });
    }
  }, [locales.data]);

  useEffect(() => {
    const { lang } = qs.parse(location.search);
    let existsLocale;
    if (locales.data?._id) {
      [existsLocale] = _.filter(userEnv.locales, (locale) => locale._id === locales.data?._id);
    }
    if (_.size(userEnv.locales) && (!existsLocale || lang || !locales.data?._id)) {
      const userLang = lang || navigator.language || navigator.userLanguage;
      const [code] = _.split(userLang, "-");
      const [bestLocale] = _.filter(
        userEnv.locales,
        (locale) => _.toLower(locale.code) === _.toLower(code),
      );
      const [defaultLocale] = _.filter(userEnv.locales, (locale) => locale.isDefault);
      const [firstLocale] = userEnv.locales;
      const locale = bestLocale || defaultLocale || firstLocale;

      if (locale) {
        props.setLocaleData(locale);
        props.setLocale(_.toLower(locale.code));
      }
    }
  }, [userEnv]);

  useEffect(() => {
    console.log("init layout", window.WebApp);
    if (window.WebApp) {
      console.log("init data", window.WebApp.initData);
    }

    // если нет сессии, то определим её
    if (!authStore.session) {
      dispatch(auth.actions.session({}));
    } else {
      // если указан webapp пользователь, то выполним процедуру авторизации из телеграм данных
      // const webAppData = { ...WebApp.initDataUnsafe };
      // если подразумевается, что есть телеграм-обертка, то авторизуем телеграм-пользователя

      if (TelegramApp.initData) {
        telegramAuthHandler();
      } else if (MaxApp.initData) {
        maxAuthHandler();
      } else if (localStorage.getItem(accessToken)) {
        // иначе проверим, что надо авторизовать пользователя по токену
        dispatch(
          sessionApi.actions.getUser(
            {},
            {
              onSuccess() {
                setAuthCheckSuccess(true);
              },
              onFailure() {
                localStorage.removeItem(accessToken);
                setAuthCheckSuccess(true);
              },
            },
          ),
        );
      } else {
        // иначе пропустим как гостевой доступ
        setAuthCheckSuccess(true);
      }

      props.settings();
      props.soundsSettings();
      props.soundsBackgrounds();
      props.systemEnv();
      props.clearWhatsAppMessage();

      // // если указан webapp пользователь, то выполним процедуру авторизации из телеграм данных
      // if (webAppData.user) {
      //   setTelegramAuthWait(true);
      // }
    }
  }, [authStore.session]);

  return authStore.session &&
    authCheckSuccess &&
    props.env?.settings &&
    props.env?.soundsSettings &&
    props.env?.soundsBackgrounds &&
    props.env?.landings
    ? props.children
    : null;
};

const mapStateToProps = (state) => ({
  userEnv: state.user.env,
  userSession: state.user.session,
  env: state.frontend.env,
  locales: state.locales,
});

export default connect(mapStateToProps, {
  ...env.actions,
  ...systemEnv.actions,
  ...sessionApi.actions,
  authApi,
  setLocaleData,
  resetPlayer,
  setLocale: IntlActions.setLocale,
  clearWhatsAppMessage,
  telegramAuth: auth.post("/telegram/app"),
  maxAuth: auth.post("/max/app"),
})(InitLayout);
